import { Validator } from './Validator';
import { ValidationError } from './ValidatorError';
export class SendSurveyMessageActionSettingsValidator extends Validator {
    validate(model) {
        if (!model.type) {
            throw new ValidationError('The survey type is required');
        }
        if (!model.scale) {
            throw new ValidationError('The survey scale content type is required');
        }
        if (!model.surveyContent) {
            throw new ValidationError('The survey scale content type is required');
        }
    }
}
